import type { PlanStateRecord, QuotaState } from '../core/types.js';
import { applyUsageNormalized as quotaApplyNormalized, closePeriodIfDue } from './quota-engine.js';

export function ensureSecondaryRolled(record: PlanStateRecord, now: Date = new Date()): PlanStateRecord {
  if (!record.secondaryQuota) return record;
  const r = closePeriodIfDue(record.secondaryQuota, 'steady', now);
  if (!r.closed) return record;
  return { ...record, secondaryQuota: r.state };
}

export function applySecondaryUsage(
  record: PlanStateRecord,
  now: Date = new Date(),
  domainUnits: number = 1,
): { record: PlanStateRecord; over: boolean; explanation?: string } {
  if (!record.secondaryQuota) return { record, over: false };
  const r = quotaApplyNormalized(record.secondaryQuota, 'steady', now, domainUnits);
  return { record: { ...record, secondaryQuota: r.state }, over: r.over, explanation: r.explanation };
}

export function newWeeklyCap(baseline: number, starting: number): QuotaState {
  const start = new Date();
  const end = new Date(start.getTime() + 7 * 86400_000);
  return {
    planType: 'quota', period: 'weekly',
    baselineQuota: baseline, currentQuota: starting,
    periodStartedAt: start.toISOString(), periodEndsAt: end.toISOString(),
    usedThisPeriod: 0, reductionStep: 1, successPeriods: 0,
  };
}
